export default __webpack_public_path__ + "static/media/slider-arrow.360b2765.svg";